import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/buyVip/success-icon.png'
import _imports_1 from '../../assets/images/buyVip/browser.png'
import _imports_2 from '../../assets/images/buyVip/paper.png'


const _withScopeId = n => (_pushScopeId("data-v-9df4a52c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "buy-success-tips" }
const _hoisted_2 = { class: "buy-success-tips-top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_5 = { class: "browser-history-box" }
const _hoisted_6 = { class: "browser-history" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "browser-pre-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "",
    class: "brower-icon"
  }),
  /*#__PURE__*/_createElementVNode("span", null, "上次浏览")
], -1))
const _hoisted_8 = { class: "browser-info" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "paper-img"
}, null, -1))
const _hoisted_10 = { class: "paper-info" }
const _hoisted_11 = { class: "paper-title" }

import { useStore } from "vuex";
import { ref, computed } from "vue";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'BuyPaperSuccess',
  props: {
    paySuccessInfo: { default: () => ({}) }
  },
  emits: ['toCloseSinglePaperDia'],
  setup(__props: any, { emit }) {

const props = __props;

/**
 * @description:单卷购买成功弹窗
 *
 */
let store = useStore();
let router = useRouter();
const preBrowseInfo = computed(() => store.state.paperPreBrowse.preBrowse);



//查看上次浏览的试卷 --跳转到试卷详情页
const toCheck = () => {
  emit('toCloseSinglePaperDia')
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(_ctx.paySuccessInfo.goodsType == 1 ? "购买成功" : "试卷购买成功"), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paySuccessInfo.msgs, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "vip-name-text",
          style: _normalizeStyle({ marginTop: index === 0 ? '10px' : '0' }),
          key: index
        }, _toDisplayString(item), 5))
      }), 128))
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(preBrowseInfo.value?.name), 1),
            _createElementVNode("div", {
              class: "check-paper-btn",
              onClick: toCheck
            }, "查看")
          ])
        ])
      ])
    ])
  ], 64))
}
}

})